import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UsersUserResponse } from '@libs/generated-types/users';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { PreEmploymentSelfserviceDialogComponent } from "../../../@core/components/pre-employment/pre-employment-activities/pre-employment-selfservice-dialog/pre-employment-selfservice-dialog.component";
import { RecrutimentSelfServiceType } from '../../../@core/data/recruitment';
import { UsersService } from '../../../services/users.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PreEmploymentActivitiesService } from '../../../services/pre-employment-activities.service';
import { PreEmploymentListActivitiesComponent } from '../../../components/pre-employment-list-activities/pre-employment-list-activities.component';
import { SelfserviceActivityListUserResponse } from '../../../../../../../libs/shared/generated/src/lib/types/selfservice';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { PreEmploymentAcknowledgementDialogComponent } from '../../../@core/components/pre-employment/pre-employment-activities/pre-employment-acknowledgement-dialog/pre-employment-acknowledgement-dialog.component';
import { PreEmploymentFileUploadDialogComponent } from '../../../@core/components/pre-employment/pre-employment-activities/pre-employment-file-upload-dialog/pre-employment-file-upload-dialog.component';

export enum OrderBy {
  ASC = 'asc',
  DESC = 'desc',
}

enum CompanyId {
  ESSELUNGA = 'E001',
  ESSERBELLA = 'E073',
  ATLANTIC = 'E002',
}

@Component({
  selector: 'app-pre-employment-activities',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    ListboxModule,
    PreEmploymentSelfserviceDialogComponent,
    PreEmploymentFileUploadDialogComponent,
    PreEmploymentListActivitiesComponent,
    TranslateModule,
    ToastModule,
    PreEmploymentAcknowledgementDialogComponent
  ],
  templateUrl: './pre-employment-activities.component.html',
  styleUrls: ['./pre-employment-activities.component.scss'],
  standalone: true,
})
export class PreEmploymentActivitiesComponent implements OnInit {
  @Input() showHeader: boolean | undefined;

  me: UsersUserResponse | null = null;
  listActivities: SelfserviceActivityListUserResponse | null = null

  openSelfserviceDialog: boolean = false;
  openUploadFileDialog: boolean = false;
  openInspectionDialog: boolean = false;

  selectedActivity: any = null;

  selfServiceType: RecrutimentSelfServiceType;

  constructor(
    private usersService: UsersService,
    private oidcSecurityService: OidcSecurityService,
    private preEmploymentActivitiesService: PreEmploymentActivitiesService,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.usersService.getUsersMe().subscribe({
      next: (response) => {
        this.me = response;
      },
      error: (error) => {
        console.error('Error fetching user data:', error);
      }
    });
    this.loadActivities();
  }
  get shouldShowHeader(): boolean {
    return this.showHeader !== false;
  }

  loadActivities(): void {
    this.preEmploymentActivitiesService.getAllPreEmploymentActivities().subscribe({
      next: (response) => {
        this.listActivities = response;
      },
      error: (error) => {
        console.error('Error fetching user list activities', error);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('pre-employment-activities.toast-summary-error-message'),
          detail: this.translate.instant('pre-employment-activities.toast-error-message'),
        });
      }
    });
  }

  onClickActivity(activity: any): void {
    this.selectedActivity = activity;
    if (activity.kind === 'SELF_SERVICE') {
      this.selfServiceType = RecrutimentSelfServiceType[activity.selfServiceKind as keyof typeof RecrutimentSelfServiceType];
      this.openSelfserviceDialog = true;
    } else if (activity.kind === 'FILE_UPLOAD') {
      this.openUploadFileDialog = true;
    } else if (activity.kind === 'ACKNOWLEDGEMENT') {
      this.openInspectionDialog = true;
    }
    else if (activity.kind === 'SIGN_DOCUMENTS') {
      window.open('/hr-documentation', '_blank', 'noopener');
    }

  }

  onCloseDialog(): void {
    this.selectedActivity = null;
    this.openSelfserviceDialog = false;
    this.openInspectionDialog = false;
    this.openUploadFileDialog = false;
  }

  getCompanyColor(companyId: string): string {
    if (!companyId) {
      return 'linear-gradient(90deg, #00205B 0%, #1e3c72 100%)';
    }
    switch (companyId) {
      case CompanyId.ESSELUNGA:
        return 'rgb(0,32,91)';
      case CompanyId.ESSERBELLA:
        return 'rgb(33,74,90)';
      case CompanyId.ATLANTIC:
        return 'rgb(35,0,130)';
      default:
        return 'linear-gradient(90deg, #00205B 0%, #1e3c72 100%)';
    }
  }
  logout() {
    const loginOidc = localStorage.getItem('oidc-login') ?? undefined;
    this.oidcSecurityService.logoff(loginOidc).subscribe(() => {
      localStorage.removeItem('oidc-login');
    });
  }
}